import { render, staticRenderFns } from "./ReferenceDialog.vue?vue&type=template&id=3556371c&"
import script from "./ReferenceDialog.vue?vue&type=script&lang=js&"
export * from "./ReferenceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceDialog.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
